/**
 * Canonical pause reasons used across the application.
 * These are used for pause dialogs and pause-time analytics.
 */
export const PAUSE_REASONS = [
  'Waiting for parts',
  'Customer approval',
  'Tech on break',
  'Awaiting diagnostics',
  'Blocked by other job',
  'Other',
] as const;

/**
 * @deprecated Break failsafe auto-pause has been disabled.
 * This constant is kept for backward compatibility with existing data.
 * No new tickets will be paused with this reason.
 */
export const BREAK_FAILSAFE_REASON = 'break_failsafe' as const;

/**
 * All pause reasons including system-only ones.
 * Use PAUSE_REASONS for user-selectable options.
 */
export const ALL_PAUSE_REASONS = [...PAUSE_REASONS, BREAK_FAILSAFE_REASON] as const;

export type PauseReason = typeof PAUSE_REASONS[number];
